import { styled } from 'styled-components';

export const StyledMain = styled.main`
  flex: 1 1 auto;
`;